import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import "./offCanvas.css";

export default function OffCanvas({
  mainwidth,
  setMainWidth,
  opaacity,
  setOpacity,
  canvasWidth,
  setCanvasWidth,
  hide,
  setHide,
  closeAllCollapses,
}) {
  // Access permissions array from Redux store
  const permissions = useSelector((state) => state.emp.permissions);

  const product = [
    {
      id: "DashBoard",
      header: "DashBoard",
      icon: "lni lni-grid-alt",
      link: "/user/home",
    },
    {
      id: "adminmanagementID",
      header: "Admin",
      icon: "lni lni-user",
      Childs: [
        { id: "functionalitiesID", Name: "Functionalities", link: "/user/functions" },
        { id: "branchesID", Name: "Branchs", link: "/user/branchs" },
        { id: "departmentsID", Name: "Departments", link: "/user/deps" },
        { id: "jobpositionsID", Name: "JobPositions", link: "/user/positions" },
        { id: "shiftsID", Name: "Shifts", link: "/user/shifts" },
      ],
    },
    {
      id: "employeemanagementID",
      header: "Employee",
      icon: "lni lni-users",
      Childs: [
        { id: "employeelistID", Name: "Total Employees", link: "/user/emp" },
        { id: "employeeaddID", Name: "Add Employee", link: "/user/addemp" },
        { id: "salaryslipsID", Name: "Salary Slips", link: "/user/salaryslip" },
        { id: "coursesID", Name: "Courses", link: "/user/courses" },
        { id: "subjectsID", Name: "Subjects", link: "/user/subcourses" },
      ],
    },
    {
      id: "leavemanagementID",
      header: "Leaves",
      icon: "lni lni-protection",
      Childs: [
        { id: "todayleavesID", Name: "Today Leaves", link: "/user/todayLeaves" },
        { id: "leaverequestsID", Name: "Leave Requests", link: "/user/leaveRequest" },
        { id: "leavereportID", Name: "Leave Report", link: "/user/leaveReport" },
        { id: "myleavesID", Name: "My Leaves", link: "/user/selfLeave" },
        { id: "companyleavesID", Name: "Company Leaves", link: "/user/leaveShow" },
        { id: "balanceleavesID", Name: "Balance Leaves", link: "/user/blncleaves" },
      ],
    },
    {
      id: "rolesmanagementID",
      header: "Roles",
      icon: "lni lni-layout",
      Childs: [
        { id: "totalrolesID", Name: "Total Roles", link: "/user/userdetails" },
      ],
    },
    {
      id: "attendencemanagementID",
      header: "Attendance",
      icon: "bi bi-calendar2-week",
      Childs: [
        { id: "allattendanceID", Name: "All Attendance", link: "/user/attendence" },
        { id: "employeeattendancereportID", Name: "Attendance Report", link: "/user/attreport" },
        { id: "attendanceregularizationID", Name: "Regularization", link: "/user/regular" },
        { id: "earlyandlateID", Name: "Early & Late", link: "/user/earlyLate" },
        { id: "myattendanceID", Name: "My Attendance", link: "/user/myattendence" },
        { id: "workinghoursID", Name: "Working Hours", link: "/user/workinghours" },
      ],
    },
    {
      id: "vacationcampID",
      header: "VacationCamp",
      icon: "bi bi-book",
      Childs: [
        { id: "liststudentsID", Name: "List Students", link: "/user/listing" },
        { id: "addstudentsID", Name: "Add Students", link: "/user/addstd" },
        { id: "batchesID", Name: "Batches", link: "/user/batches" },
        { id: "studentattendancereportID", Name: "Attendance Report", link: "/user/streport" },
        { id: "feereportID", Name: "Fee Report", link: "/user/feereport" },
      ],
    },
  ];

  // Filter product array and child items based on permissions
  const filteredProduct = product
    .map((item) => {
      if (item.id === "DashBoard") {
        return item; // Always include DashBoard
      }

      // Filter child items based on permissions
      const permittedChildren = item.Childs
        ? item.Childs.filter((child) => permissions.includes(child.id))
        : [];

      // Include parent if it has permitted children or its own ID is in permissions
      if (permittedChildren.length > 0 || permissions.includes(item.id)) {
        return {
          ...item,
          Childs: permittedChildren,
        };
      }

      return null;
    })
    .filter((item) => item !== null);

  // Function to toggle the sidebar width
  function settingWidth() {
    if (!mainwidth) {
      setMainWidth(true);
      setCanvasWidth("250px");
      setTimeout(() => {
        setOpacity("100%");
        setHide("block");
      }, 300);
    } else {
      setMainWidth(false);
      setCanvasWidth("50px");
      setOpacity("0%");
      setHide("none");
      closeAllCollapses(); // Close all collapses when collapsing the off-canvas menu
    }
  }

  // Function to handle dropdown toggle
  const handleDropdown = (id) => {
    const dropdownMenu = document.getElementById(id);
    if (dropdownMenu) {
      if (dropdownMenu.classList.contains("show")) {
        dropdownMenu.classList.remove("show");
      } else {
        dropdownMenu.classList.add("show");
      }
    }
  };

  return (
    <div>
      <div
        style={{ width: canvasWidth, left: "0" }}
        className="sideBar position-fixed"
      >
        <div
          className="accordion accordion-flush"
          style={{ width: canvasWidth }}
          id="accordionFlushExample"
        >
          {filteredProduct.map((item, index) => (
            <div className="accordion-item w-100" key={item.id}>
              <div
                className="button_Container w-100"
                onMouseEnter={() => item.Childs && handleDropdown(`dropdownMenu_${item.id}`)}
                onMouseLeave={() => item.Childs && handleDropdown(`dropdownMenu_${item.id}`)}
              >
                {item.link ? (
                  <Link
                    to={item.link}
                    className="w-100 text-decoration-none d-flex align-items-center h-100"
                    style={{ color: "inherit" }}
                  >
                    <i
                      className={`icons ${item.icon} d-flex justify-content-center`}
                      onClick={() => settingWidth()}
                    ></i>
                    <p
                      className="icon-text mb-0 w-100 h-100 text-nowrap"
                      style={{ display: hide, opacity: opaacity }}
                    >
                      {item.header}
                    </p>
                  </Link>
                ) : (
                  <>
                    <i
                      className={`icons ${item.icon} d-flex justify-content-center`}
                      onClick={() => settingWidth()}
                    ></i>
                    <p
                      className="icon-text mb-0"
                      style={{ display: hide, opacity: opaacity }}
                    >
                      {item.header}
                    </p>
                  </>
                )}
                {item.Childs && item.Childs.length > 0 && (
                  <button
                    style={{ display: hide }}
                    className="accordion-button collapsed d-flex justify-content-center rounded-0"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#flush-collapse${item.id}`}
                    aria-expanded="false"
                    aria-controls={`flush-collapse${item.id}`}
                  >
                    <i
                      className="lni lni-chevron-down"
                      style={{ display: hide }}
                    ></i>
                  </button>
                )}
                {item.Childs && item.Childs.length > 0 && (
                  <div className="dropdown dropend" style={{ zIndex: 30 }}>
                    <ul
                      className="dropdown-menu p-0"
                      style={{ zIndex: 30 }}
                      id={`dropdownMenu_${item.id}`}
                    >
                      {item.Childs.map((child) => (
                        <li key={child.id} style={{ height: "35px", zIndex: 30 }}>
                          <Link
                            to={child.link}
                            className="dropdown-item"
                            style={{ zIndex: "30" }}
                          >
                            {child.Name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
              {item.Childs && item.Childs.length > 0 && (
                <div
                  id={`flush-collapse${item.id}`}
                  className="accordion-collapse collapse"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    {item.Childs.map((child) => (
                      <button key={child.id} className="btn w-100 text-start rounded-0">
                        <Link className="w-100 h-100" to={child.link}>
                          {child.Name}
                        </Link>
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}